'use strict';

var errCode = require('err-code');

var resolvers = {
  'dag-pb': require('./unixfs-v1'),
  raw: require('./raw'),
  'dag-cbor': require('./dag-cbor'),
  identity: require('./identity')
};

var resolve = function resolve(cid, name, path, toResolve, depth, ipld, options) {
  var resolver = resolvers[cid.codec];

  if (!resolver) {
    throw errCode(new Error("No resolver for codec ".concat(cid.codec)), 'ERR_NO_RESOLVER');
  }

  return resolver(cid, name, path, toResolve, resolve, depth, ipld, options);
};

module.exports = resolve;